// extracted by mini-css-extract-plugin
export default {"outerContainer":"style_outerContainer__i76Va"};